import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import './PotentialScoreFactorsModule.scss';
import FactorActionComponent from 'components/FactorActionComponent/FactorActionComponent';
import CardsConfig from '../PaymentHistoryActionsModule/config';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import PotentialCreditFactorsTips from 'partial_OfferManager_modules_PotentialScoreFactorsModule/PotentialCreditFactorsTips';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';
import classnames from 'classnames';
import { isPremium } from 'helpers/userHelper';
const {
  PAYMENT_HISTORY,
  ACCOUNT_MIX,
  CREDIT_AGE,
  CREDIT_INQUIRIES,
  CREDIT_USAGE,
} = FACTOR_ENUMS;

const getColorByGrade = grade => {
  switch (grade) {
    case 'A':
      return 'green3';
    case 'B':
      return 'lgreen3';
    case 'C':
      return 'yellow2';
    case 'D':
      return 'orange2';
    case 'F':
      return 'red3';
    default:
      return 'gray bgGray025';
  }
};

const GradeFactors = props => {
  const {
    grade,
    title,
    subtitle,
    handleClickInFactor,
    selectedPotentialFactor,
    seenOfferModulePosition,
  } = props;
  const eventClickType = 'Navigation';
  const color = getColorByGrade(grade);
  const gradeLetter = grade ? grade : 'N/A';

  const labelClass = classnames({
    'system_neutral_n200_text  m-text-16 whitespace-nowrap': !grade,
  });

  return (
    <FlexContainer className={'justify-between items-align-center width100'}>
      <FlexContainer>
        <FlexContainer
          className={`${color} width40px height40px justify-center items-align-center borderRadius2 margR16`}
        >
          <Label type="H5" className={`${labelClass} width50px text-center`}>
            {gradeLetter}
          </Label>
        </FlexContainer>
        <FlexContainer className={'flex-column'}>
          <Label type={'Subtitle-1'}>{title}</Label>
          <Label type={'Overline toUpper'}>{subtitle}</Label>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer
        onClick={() => {
          handleClickInFactor(
            selectedPotentialFactor,
            seenOfferModulePosition,
            eventClickType,
          );
        }}
        tabIndex={'0'}
        role={'button'}
      >
        <Image className={'notificationChevronRight pointer'} />
      </FlexContainer>
    </FlexContainer>
  );
};

const gradeBasedOnFactor = (selectedPotentialFactor, factor) => {
  const isNotGradeAorB =
    !(factor?.grade === 'A' || factor?.grade === 'B') && factor?.grade;

  const isMoreThanYear = factor?.averageCreditAgeInMonths >= 12;

  switch (selectedPotentialFactor) {
    case CREDIT_AGE:
      if (isNotGradeAorB) {
        return isMoreThanYear ? 'C_F_MORE1YEAR' : 'C_F';
      }
      return factor?.grade;
    case CREDIT_INQUIRIES:
      return isNotGradeAorB ? 'C_F' : factor?.grade;
    default:
      return factor?.grade;
  }
};

const formatCreditAgeTime = averageCreditAgeInMonths => {
  const years = Math.floor(averageCreditAgeInMonths / 12);
  const months = averageCreditAgeInMonths % 12;

  return years > 0 ? `${years} YEARS ${months} MONTHS` : `${months} MONTHS`;
};

const CreditUsageSuggestedUsage = props => {
  const { selectedPotentialFactor, factor } = props;
  if (
    selectedPotentialFactor === CREDIT_USAGE &&
    factor?.grade !== 'A' &&
    factor?.grade &&
    factor?.currentUsageOverSuggested
  ) {
    return (
      <FlexContainer
        className={
          'bgWhite grayShadow borderRadius8 padTB8 padLR16 flex-column Subtitle-2'
        }
      >
        <FlexContainer className={'justify-between'}>
          <Label className="notBold">
            Suggested max usage ({factor?.suggestedMaxPercentage}%)
          </Label>
          <Label>${factor?.suggestedMaxAmount}</Label>
        </FlexContainer>
        <FlexContainer className={'justify-between'}>
          <Label className="notBold">Over suggested usage by</Label>
          <Label className={'fontRedR300'}>
            ${factor?.currentUsageOverSuggested}
          </Label>
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

const ScoreFactors = props => {
  const {
    id,
    factor,
    actionFactor,
    eventHandler,
    history,
    titleFactor,
    subtitleFactor,
    selectedPotentialFactor,
    handleClickInFactor,
    seenOfferModulePosition,
    handleClickOpeningNewCreditCard,
    handleClickBereauReport,
    handleClickGettingNewCard,
    handleClickOpenAccountToday,
    handleClickExploreAllPremiumBenefits,
    isPremiumUser,
    config,
  } = props;

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: `Potential - ${factorMapping?.get(selectedPotentialFactor)}`,
    modulePosition: seenOfferModulePosition,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  return (
    <FlexContainer className={'padLR14 m-padLR0'} id={id}>
      {seenModuleTracking}
      <FlexContainer
        className={
          'grayShadow width100 flex-column pad26 m-pad16 gap-16 borderRadius8'
        }
      >
        <GradeFactors
          grade={factor?.grade}
          title={titleFactor}
          subtitle={subtitleFactor}
          handleClickInFactor={handleClickInFactor}
          selectedPotentialFactor={selectedPotentialFactor}
          seenOfferModulePosition={seenOfferModulePosition}
        />
        <FlexContainer
          className={'bgBlue015 pad12 borderRadius4 flex-column gap-6'}
        >
          <PotentialCreditFactorsTips
            grade={gradeBasedOnFactor(selectedPotentialFactor, factor)}
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            factor={factor}
            seenOfferModulePosition={seenOfferModulePosition}
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
            handleClickBereauReport={handleClickBereauReport}
            handleClickGettingNewCard={handleClickGettingNewCard}
            handleClickOpenAccountToday={handleClickOpenAccountToday}
            handleClickExploreAllPremiumBenefits={
              handleClickExploreAllPremiumBenefits
            }
            isPremiumUser={isPremiumUser}
          />
          <CreditUsageSuggestedUsage
            selectedPotentialFactor={selectedPotentialFactor}
            factor={factor}
          />
          {actionFactor?.length > 0 && (
            <Disclaimer className="creditFactor margT8" />
          )}
          {actionFactor?.length > 0 &&
            actionFactor?.map((action, index) => {
              const { image, linkPath } = CardsConfig[action?.name];
              const offer = action?.offers[0];
              return (
                <FlexContainer key={'action' + index}>
                  <FactorActionComponent
                    key={'goalAction' + index}
                    name={action?.name}
                    text={action?.actionCardText}
                    image={image}
                    url={linkPath}
                    offer={offer}
                    offerModulePosition={index + 1}
                    eventHandler={eventHandler}
                    history={history}
                    selectedFactor={selectedPotentialFactor}
                    seenOfferModuleName={`Potential - `}
                    seenOfferModulePosition={seenOfferModulePosition}
                    config={config}
                  />
                </FlexContainer>
              );
            })}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const PotentialScoreFactorsModuleView = props => {
  const {
    eventHandler,
    history,
    paymentHistory,
    creditUsage,
    creditAge,
    accountMix,
    creditInquiries,
    handleClickInFactor,
    handleClickOpeningNewCreditCard,
    handleClickBereauReport,
    handleClickGettingNewCard,
    handleClickOpenAccountToday,
    handleClickExploreAllPremiumBenefits,
    config,
    userInfo,
  } = props;

  const onlyPotentialActions = factor => {
    return factor?.actions?.filter(action =>
      action?.displayArea?.includes('POTENTIAL_TAB'),
    );
  };

  const accountMixTotalOpenLoanAccounts =
    accountMix?.accountMixSummary?.totalOpenLoanAccounts === 1
      ? '1 LOAN'
      : `${accountMix?.accountMixSummary?.totalOpenLoanAccounts} LOANS`;
  const subTitle = config?.tips?.factors?.potential?.subtitle;
  const isPremiumUser = isPremium(userInfo);
  const totalInquiriesInPast12Months =
    creditInquiries?.inquiriesSummary?.totalInquiriesInPast12Months | 0;
  return (
    <FlexContainer
      className={
        'flex-column potentialScoreFactors padLR28 m-padLR16 padTB30  m-padTB16'
      }
    >
      {config?.showPotentialDisclosure && (
        <FlexContainer className={'flex-column  margB32 m-margB16'}>
          <Label type={'Body-2'}>
            Your "potential" estimate is based on analysis of the credit
            profiles of certain other credit monitoring members, and your actual
            score results may vary. Any credit score impact is the result of
            many factors, including activity related to paying bills, keeping
            credit balances low, avoiding unnecessary hard inquiries,
            appropriate financial planning, and developing better credit habits.
            TransUnion does not guarantee you will experience these results, and
            you may even see a decrease in your credit score.
          </Label>
        </FlexContainer>
      )}
      <FlexContainer className={'flex-column  margB32 m-margB16'}>
        <Label type={'H5'} typeHeader={'h5'}>
          Factors that make up your credit score
        </Label>
        <Label type={'Body-2 italic'}>{subTitle}</Label>
      </FlexContainer>
      <FlexContainer className={'flex-column gap-32 m-gap-16'}>
        <ScoreFactors
          id={PAYMENT_HISTORY}
          titleFactor={'Payment History'}
          subtitleFactor={`$${paymentHistory?.paymentHistorySummary?.totalMonthlyPayment}/mo | ${paymentHistory?.paymentHistorySummary?.totalNegativeMarkAccountCount} negative | 40% Impact`}
          factor={paymentHistory?.paymentHistorySummary}
          actionFactor={onlyPotentialActions(paymentHistory)}
          eventHandler={eventHandler}
          history={history}
          selectedPotentialFactor={PAYMENT_HISTORY}
          handleClickInFactor={handleClickInFactor}
          seenOfferModulePosition={1}
          handleClickBereauReport={handleClickBereauReport}
          handleClickExploreAllPremiumBenefits={
            handleClickExploreAllPremiumBenefits
          }
          isPremiumUser={isPremiumUser}
          config={config}
        />
        <ScoreFactors
          id={CREDIT_USAGE}
          titleFactor={'Credit Usage'}
          subtitleFactor={`${creditUsage?.creditUsageSummary?.utilizationPercentage}% ${config?.utilization} | ${creditUsage?.creditUsageSummary?.totalOpenCcAccounts} CARDS | 34% Impact`}
          factor={creditUsage?.creditUsageSummary}
          actionFactor={onlyPotentialActions(creditUsage)}
          eventHandler={eventHandler}
          history={history}
          selectedPotentialFactor={CREDIT_USAGE}
          handleClickInFactor={handleClickInFactor}
          seenOfferModulePosition={2}
          handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
          config={config}
        />
        <ScoreFactors
          id={CREDIT_AGE}
          titleFactor={config?.creditFactors?.potential?.credit_age?.title}
          subtitleFactor={`${formatCreditAgeTime(
            creditAge?.creditAgeSummary?.averageCreditAgeInMonths,
          )} | 21% Impact ${
            config?.creditFactors?.potential?.credit_age?.subtitleFactor
          }`}
          factor={creditAge?.creditAgeSummary}
          actionFactor={onlyPotentialActions(creditAge)}
          eventHandler={eventHandler}
          history={history}
          selectedPotentialFactor={CREDIT_AGE}
          handleClickInFactor={handleClickInFactor}
          seenOfferModulePosition={3}
          handleClickGettingNewCard={handleClickGettingNewCard}
          config={config}
        />
        <ScoreFactors
          id={ACCOUNT_MIX}
          titleFactor={config?.creditFactors?.potential?.account_mix?.title}
          subtitleFactor={`${accountMix?.accountMixSummary?.totalOpenCcAccounts} CREDIT CARDS | ${accountMixTotalOpenLoanAccounts} | 21% IMPACT ${config?.creditFactors?.potential?.account_mix?.subtitleFactor}`}
          factor={accountMix?.accountMixSummary}
          actionFactor={onlyPotentialActions(accountMix)}
          eventHandler={eventHandler}
          history={history}
          selectedPotentialFactor={ACCOUNT_MIX}
          handleClickInFactor={handleClickInFactor}
          seenOfferModulePosition={4}
          handleClickOpenAccountToday={handleClickOpenAccountToday}
          config={config}
        />
        <ScoreFactors
          id={CREDIT_INQUIRIES}
          titleFactor={config?.creditFactors?.potential?.creditInquiries?.title}
          subtitleFactor={`${totalInquiriesInPast12Months} HARD CREDIT ${
            totalInquiriesInPast12Months === 1 ? 'INQUIRY' : 'INQUIRIES'
          } | 5% IMPACT`}
          factor={creditInquiries?.inquiriesSummary}
          actionFactor={onlyPotentialActions(creditInquiries)}
          eventHandler={eventHandler}
          history={history}
          selectedPotentialFactor={CREDIT_INQUIRIES}
          handleClickInFactor={handleClickInFactor}
          seenOfferModulePosition={5}
          config={config}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default PotentialScoreFactorsModuleView;
